/**
 * Retrieve a value from local storage, with an optional default
 *
 * @param {string} key - the key that the value is stored under
 * @param {*} defaultValue - a default value to return if there is no value stored
 * @returns {*} - the value from local storage or the default value
 */
export const getJsonItem = (key, defaultValue) => {
    const storageItem = localStorage.getItem(key);
    return storageItem !== null
        ? JSON.parse(storageItem)
        : defaultValue;
};

/**
 * Retrieve a value from local storage
 *
 * @param {string} key - the key that the value is stored under
 * @returns {*} - the value from local storage or the default value
 */
export const getItem = (key) => {
    return localStorage.getItem(key);
};

/**
 * Set a value in local storage. Will be converted to JSON for storage.
 *
 * @param {string} key - the key to store the value under
 * @param {*} value - the value to store
 */
export const setJsonItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));

/**
 * Set a value in local storage.
 *
 * @param {string} key - the key to store the value under
 * @param {*} value - the value to store
 */
export const setItem = (key, value) => localStorage.setItem(key, value);

/**
 * Remove an item from the local storage, with an optional default
 *
 * @param {string} key - the key that the value is stored under
 */
export const removeItem = (key) => localStorage.removeItem(key);

/**
 * Empties the list associated with the object of all key/value pairs, if there are any.
 */
export const clear = () => localStorage.clear();

const defaultLocalStorage = {
    getJsonItem,
    setJsonItem,
    removeItem,
    clear,
    setItem,
    getItem
};

export default defaultLocalStorage;
